module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-e1ab8483.png";